import React from 'react';

const DateInput = ({ label, startValue, endValue, onChangeStart, onChangeEnd }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
    <div className="flex space-x-2">
      <input
        type="date"
        value={startValue}
        onChange={(e) => onChangeStart(e.target.value)}
        className="w-1/2 border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Start date"
      />
      <input
        type="date"
        value={endValue}
        onChange={(e) => onChangeEnd(e.target.value)}
        className="w-1/2 border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="End date"
      />
    </div>
  </div>
);

const DateRangeSection = ({
  uploadStart,
  uploadEnd,
  takenStart,
  takenEnd,
  onDateChange
}) => {
  const handleDateChange = (value, field) => {
    onDateChange(value, field);
  };

  return (
    <details className="group border-t border-gray-200 pt-6">
      <summary className="cursor-pointer text-sm font-medium text-gray-700 hover:text-gray-900 flex items-center space-x-2 py-2">
        <span>Advanced Filters</span>
        <svg className="w-4 h-4 transition-transform group-open:rotate-180 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </summary>

      <div className="mt-4 space-y-6">
        <DateInput
          label="Upload Date Range"
          startValue={uploadStart}
          endValue={uploadEnd}
          onChangeStart={(value) => handleDateChange(value, 'uploadStart')}
          onChangeEnd={(value) => handleDateChange(value, 'uploadEnd')}
        />

        <DateInput
          label="Photo Taken Date Range"
          startValue={takenStart}
          endValue={takenEnd}
          onChangeStart={(value) => handleDateChange(value, 'takenStart')}
          onChangeEnd={(value) => handleDateChange(value, 'takenEnd')}
        />
      </div>
    </details>
  );
};

export default DateRangeSection;
